module.exports = __webpack_public_path__ + "img/Res_Mus_4kl.efb7bb04.jpg";